// frontend/src/pages/legal/Cookies.jsx
import React from 'react';
import LegalLayout from './LegalLayout';

const Cookies = () => (
  <LegalLayout title="Cookie Policy" lastUpdated="22 September 2026">
    <h2>1. Essential Cookies</h2>
    <p>
      We use essential session cookies and tokens strictly required for authentication and security (e.g., keeping you logged in) and processing payments via Stripe. These cookies are strictly necessary under the ePrivacy Directive and cannot be disabled.
    </p>

    <h2>2. Performance Telemetry</h2>
    <p>
      We may collect non-identifying performance telemetry to monitor application speed and API uptime. We do not use third-party advertising cookies or cross-site tracking scripts.
    </p>

    <h2>3. Managing Cookie Preferences</h2>
    <p>
      You can configure your browser to block or alert you about cookies, though blocking essential cookies will prevent the webapp from functioning properly.
    </p>
  </LegalLayout>
);

export default Cookies;